"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCronRefined = void 0;
/**
 * Build config data
 * @param slaProperties
 * @returns {*} {Config}
 */
const buildCronRefined = (slaProperties) => ({
    ID: slaProperties.ID,
    title: slaProperties.title,
    description: slaProperties.description,
    target: slaProperties.target,
    unit: slaProperties.unit,
});
exports.buildCronRefined = buildCronRefined;
//# sourceMappingURL=ConfigCronRefined.js.map